export default __webpack_public_path__ + "banner-hotf0b79c.svg";